import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    value: {
        height: '25px',
        width: '25px',
        lineHeight: '18px',
        color: theme?.app?.applicationColors.badgeColor || '#B28C69',
        border: `1px solid ${theme?.app?.applicationColors.badgeColor || '#B28C69'}`,
        borderRadius: '50%',
        boxSizing: 'border-box' as 'border-box',
        padding: '.16rem 0',
        textAlign: 'center',
        display: 'block'
    },
    singleValue: { fontSize: '13px' },
    doubleValue: { fontSize: '12px' },
    tripleValue: { fontSize: '9px' },
    inactive: {
        position: 'relative',
        '&::after': {
            top: '11px',
            left: '-1px',
            right: '-1px',
            content: '""',
            display: 'inline-block',
            position: 'absolute',
            borderTop: '1px solid',
            borderColor: 'inherit',
            '-webkit-transform': 'rotate(-45deg)',
            '-moz-transform': 'rotate(-45deg)',
            '-ms-transform': 'rotate(-45deg)',
            '-o-transform': 'rotate(-45deg)',
            transform: 'rotate(-45deg)'
        }
    }
}));